import { render, staticRenderFns } from "./try.vue?vue&type=template&id=3590ccfa&"
import script from "./try.vue?vue&type=script&lang=js&"
export * from "./try.vue?vue&type=script&lang=js&"
import style0 from "./try.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports